$(document).ready(function () {
  let nonInformedFields = document.querySelectorAll(".non-informed-profile");
  let submitButton = $('#subscribe_submit_button');

  if (submitButton.length == 0) {
    return;
  }

  submitButton.click(triggerSubscriptionConfirmModal);
  $(document).on("keydown", "#newSubscriptionForm", function(event) {
    if (event.keyCode == 13) {
      event.preventDefault();
      triggerSubscriptionConfirmModal();
      return;
    }
  });

  function triggerSubscriptionConfirmModal() {
    let subscriptionAmountField = $("#subscription_amount_field");

    amount = subscriptionAmountField.val()

    if (!subscriptionAmountField[0].checkValidity()) {
      document.getElementById("fields_errors").innerHTML = subscriptionAmountField[0].validationMessage;
      return false;
    } else if (amount === "") {
      document.getElementById("fields_errors").innerHTML = "Un montant de souscription doit être renseigné.";
      return false;
    } else {
      document.getElementById("fields_errors").innerHTML = "";
    }

    if (subscriptionAmountField.data("userMayHaveWarning") === true) {
      Rails.ajax({
        type: "GET",
        url: subscriptionAmountField.data("url"),
        data: '&[amount]=' + amount,
        dataType: "json",
        success: function(response) {
          let warning_modal_required = response["warning_modal_required"]

          if (warning_modal_required) {
            nonInformedFields.forEach(element => element.classList.remove("d-none"));
          }
          $('#subscribeModal').modal('show');
        },
        error: function(response) {
          document.getElementById("fields_errors").innerHTML = "Une erreur s'est produite, veuillez réessayer.";
        }
      });
    } else {
      $('#subscribeModal').modal('show');
    }
  };
});
